export const accordionCustomStyles = {
  width: '100%',
  boxShadow: 'unset',

  '.MuiAccordionSummary-root': {
    flexDirection: 'row-reverse',
    columnGap: '10px',
    color: ({ palette }) => palette.text.secondary,
    '.MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
  },
  '.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'unset',
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    color: ({ palette }) => palette.text.secondary,
    backgroundColor: ({ palette }) => palette.background.secondary,
    borderRadius: ({ shape }) => shape.radius.s,
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
  },
  '.accordion-summary-container.MuiStack-root': {
    padding: '0 10px',
    marginRight: '12px',
    height: '100%',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: 'auto auto',
    columnGap: '16px',
    rowGap: '2px',
    alignItems: 'center',
    '& > *': {
      margin: 0,
    },
  },
  '.accordion-summary-title': {
    gridColumn: 1,
    gridRow: 1,
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '20px',
    color: ({ palette }) => palette.text.primary,
  },
  '.disclosure-package-subtitle': {
    gridColumn: 1,
    gridRow: 2,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  '.disclosure-package-status': {
    gridColumn: 2,
    gridRow: '1 / span 2',
    justifySelf: 'end',
    alignSelf: 'center',
  },
  '.MuiAccordionDetails-root': {
    padding: '18px',
    paddingBottom: 0,
  },
};
